import { render, staticRenderFns } from "./WatchBonds.vue?vue&type=template&id=382e6980&"
import script from "./WatchBonds.vue?vue&type=script&lang=ts&"
export * from "./WatchBonds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports